const PENDING_VERIFY_KEY = 'ehgezly_pending_email_verify';
const VERIFY_FOR_BOOKING_KEY = 'ehgezly_verify_for_booking';

/** True when the user has completed email (or legacy phone) verification. */
export function isProfileEmailVerified(profile) {
  if (!profile) return true;
  return Boolean(
    profile.emailVerified === true ||
    profile.isEmailVerified === true ||
    profile.isPhoneVerified === true
  );
}

export function markPendingEmailVerification(email) {
  try {
    if (email) sessionStorage.setItem(PENDING_VERIFY_KEY, String(email).trim().toLowerCase());
  } catch {
    /* ignore */
  }
}

export function clearPendingEmailVerification() {
  try {
    sessionStorage.removeItem(PENDING_VERIFY_KEY);
  } catch {
    /* ignore */
  }
}

/** Set when user tried to book while unverified — shows verify UI on Profile only. */
export function markVerifyForBooking() {
  try {
    sessionStorage.setItem(VERIFY_FOR_BOOKING_KEY, '1');
  } catch {
    /* ignore */
  }
}

export function clearVerifyForBooking() {
  try {
    sessionStorage.removeItem(VERIFY_FOR_BOOKING_KEY);
  } catch {
    /* ignore */
  }
}

export function hasVerifyForBooking() {
  try {
    return sessionStorage.getItem(VERIFY_FOR_BOOKING_KEY) === '1';
  } catch {
    return false;
  }
}

export function hasPendingEmailVerification(profile) {
  try {
    const pending = sessionStorage.getItem(PENDING_VERIFY_KEY);
    const email = profile?.email ? String(profile.email).trim().toLowerCase() : '';
    return Boolean(pending && email && pending === email);
  } catch {
    return false;
  }
}

/**
 * Show verify banner on Profile when the logged-in user has not verified email yet.
 */
export function shouldShowProfileEmailVerification(profile) {
  if (!profile?.email) return false;
  if (isProfileEmailVerified(profile)) {
    clearVerifyForBooking();
    clearPendingEmailVerification();
    return false;
  }
  return true;
}

/**
 * Show verify banner only when logged-in user attempted a booking but email is not verified.
 */
export function shouldShowVerifyForBooking(profile) {
  if (!profile?.email) return false;
  if (isProfileEmailVerified(profile)) {
    clearVerifyForBooking();
    clearPendingEmailVerification();
    return false;
  }
  return hasVerifyForBooking();
}
